import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getCookie, setCookie } from "../../utils/cookies";
import "./AgeGate.css";
import img from '../../static/img/vm/vm-logo-wordmark.png'

const COOKIE_NAME = "age_gate_accepted";
const COOKIE_DAYS = 60;

export default function AgeGate() {
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const [showError, setShowError] = useState(false);
    
    const isExcludedRoute =
        location.pathname.startsWith("/login") ||
        location.pathname.startsWith("/dashboard");

    useEffect(() => {
        if (isExcludedRoute) return;

        const accepted = getCookie(COOKIE_NAME) === "true";
        if (!accepted) {
            setVisible(true);
        }
    }, [isExcludedRoute]);

    const handleYes = () => {
        setCookie(COOKIE_NAME, "true", { days: COOKIE_DAYS });
        setVisible(false);
    };

    const handleNo = () => {
        // intentionally empty
        console.log("No Clicked");
        setShowError(true);
    };

    if (isExcludedRoute || !visible) return null;

    return (
        <div className="agegate-overlay">
            <div className="agegate-content">
                <div className="agegate-top">
                    <div className="agegate-top-left"></div>
                    <div className="agegate-top-right">
                        <img src={img} alt="VM Logo" style={{ width: '160px', paddingTop: '10px', paddingBottom: '10px', marginLeft: '16px' , height: '21.5px'}} />
                    </div>
                </div>
                <div className="agegate-body">
                    <div>
                        <div className="agegate-welcome">
                            Welcome
                        </div>
                        <div className="agegate-body-content">
                            You must be of legal drinking age (18+) to access this website. Please confirm to continue.
                        </div>
                    </div>
                    <div className="agegate-buttons">
                        <button onClick={handleYes}>Yes</button>
                        <button onClick={handleNo}>No</button>
                    </div>

                    {showError && (
                        <div className="agegate-error">
                            You need to be 18 to enter the website.
                        </div>
                    )}

                    <div className="agegate-footer">
                        By confirming, you are agreeing to our Terms of Use & Privacy Policy.
                    </div>

                </div>


            </div>
        </div>
    );
}
